// i18n dictionaries. EN + SK full; CS/PL/HU cover primary UI strings and
// fall back to EN for the rest via the t() helper in I18nContext.
export const translations = {
  en: {
    "nav.categories": "Categories",
    "nav.how": "How it works",
    "nav.partners": "For Partners",
    "nav.about": "About",
    "nav.login": "Log in",
    "nav.signup": "Sign up",
    "nav.account": "Account",
    "nav.garage": "My Garage",
    "nav.favorites": "Favorites",
    "nav.alerts": "Price alerts",
    "nav.profile": "Profile",
    "nav.logout": "Log out",
    "nav.dashboard": "Partner Dashboard",

    "hero.badge": "Trusted across Central Europe",
    "hero.title": "Compare car parts across SK, CZ, PL & HU",
    "hero.subtitle": "One search across verified retailers. Compare total price, shipping, delivery time and seller rating — find the right part, at the right price, delivered to your door.",
    "hero.search.oem": "OEM number",
    "hero.search.ean": "EAN / barcode",
    "hero.search.name": "Part name",
    "hero.search.vehicle": "Vehicle",
    "hero.search.placeholder": "e.g. brake disc, 1K0615301, Škoda Octavia",
    "hero.search.button": "Compare prices",
    "hero.stat.retailers": "Verified retailers",
    "hero.stat.parts": "Parts indexed",
    "hero.stat.markets": "Markets",

    "cat.title": "Browse by category",
    "cat.subtitle": "Genuine, OE-matching and aftermarket parts from vetted sellers.",
    "cat.view": "View all",
    "cat.count": "products",

    "how.title": "How PartFinder works",
    "how.subtitle": "Transparent comparison in three steps.",
    "how.s1.title": "Search",
    "how.s1.text": "Enter an OEM number, EAN, part name or your vehicle to find matching parts.",
    "how.s2.title": "Compare",
    "how.s2.text": "See total landed price, shipping, delivery time, stock and seller rating side by side.",
    "how.s3.title": "Buy from the seller",
    "how.s3.text": "Continue to the verified retailer with the best offer — no markup, no middleman.",

    "trust.title": "Built on trust and transparency",
    "trust.subtitle": "We rank offers on total value, never on who pays the most.",
    "trust.1.title": "Total price, not just sticker price",
    "trust.1.text": "Shipping and delivery are always included so you compare like for like.",
    "trust.2.title": "Verified sellers only",
    "trust.2.text": "Every partner is checked for VAT registration and delivery reliability.",
    "trust.3.title": "Independent methodology",
    "trust.3.text": "Our ranking is documented and open. Read exactly how we sort offers.",
    "trust.method": "Read our methodology",

    "partner.title": "Sell more parts across four markets",
    "partner.subtitle": "Reach buyers in Slovakia, Czechia, Poland and Hungary from one integration. Feeds via API, XML or CSV.",
    "partner.cta": "Become a partner",
    "partner.b1": "Free onboarding & catalog import",
    "partner.b2": "Deduplicated OEM/EAN matching",
    "partner.b3": "Pay only for qualified clicks",

    "footer.tagline": "The independent car-parts comparison for Central Europe.",
    "footer.company": "Company",
    "footer.legal": "Legal",
    "footer.resources": "Resources",
    "footer.rights": "All rights reserved.",

    "search.results": "results",
    "search.filters": "Filters",
    "search.category": "Category",
    "search.country": "Ship from country",
    "search.instock": "In stock only",
    "search.sort": "Sort by",
    "search.sort.price_asc": "Lowest total price",
    "search.sort.price_desc": "Highest total price",
    "search.sort.offers": "Most offers",
    "search.sort.name": "Name A–Z",
    "search.empty": "No parts found. Try a different search or filter.",
    "search.all": "All categories",
    "search.allc": "All countries",
    "search.from": "from",
    "search.offers": "offers",

    "product.offers": "Offers from sellers",
    "product.compat": "Vehicle compatibility",
    "product.specs": "Details",
    "product.oem": "OEM numbers",
    "product.ean": "EAN",
    "product.brand": "Brand",
    "product.category": "Category",
    "product.total": "Total",
    "product.price": "Price",
    "product.shipping": "Shipping",
    "product.delivery": "Delivery",
    "product.seller": "Seller",
    "product.stock": "Stock",
    "product.country": "Country",
    "product.gotoseller": "Go to seller",
    "product.days": "days",
    "product.free": "Free",
    "product.instock": "In stock",
    "product.lowstock": "Low stock",
    "product.backorder": "Backorder",
    "product.bestdeal": "Best deal",
    "product.addfav": "Save",
    "product.remfav": "Saved",
    "product.setalert": "Set price alert",

    "auth.login.title": "Welcome back",
    "auth.login.subtitle": "Log in to manage your garage, favorites and alerts.",
    "auth.register.title": "Create your account",
    "auth.register.subtitle": "Save vehicles, track prices and get alerts.",
    "auth.name": "Full name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.login.button": "Log in",
    "auth.register.button": "Create account",
    "auth.toRegister": "Don't have an account? Sign up",
    "auth.toLogin": "Already have an account? Log in",

    "garage.title": "My Garage",
    "garage.subtitle": "Save your vehicles for faster compatible-part search.",
    "garage.add": "Add vehicle",
    "garage.empty": "No vehicles yet. Add your first car.",
    "fav.title": "Favorites",
    "fav.subtitle": "Parts you saved to compare later.",
    "fav.empty": "You have no favorites yet.",
    "alerts.title": "Price alerts",
    "alerts.subtitle": "We notify you when a part drops to your target price.",
    "alerts.empty": "No price alerts yet.",
    "alerts.target": "Target price",
    "alerts.current": "Current best",
    "profile.title": "Profile & settings",

    "partnerform.title": "Become a partner",
    "partnerform.subtitle": "Tell us about your store. Our team reviews applications within 2 business days.",
    "partnerform.company": "Company name",
    "partnerform.contact": "Contact person",
    "partnerform.phone": "Phone",
    "partnerform.website": "Website",
    "partnerform.catalog": "Catalog size",
    "partnerform.feed": "Preferred feed type",
    "partnerform.message": "Message",
    "partnerform.submit": "Submit application",
    "partnerform.success": "Application received! We'll be in touch shortly.",

    "contact.title": "Contact us",
    "contact.subject": "Subject",
    "contact.send": "Send message",
    "contact.success": "Thanks — your message has been sent.",

    "common.loading": "Loading…",
    "common.remove": "Remove",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.required": "Login required",
    "common.loginPrompt": "Please log in to use this feature.",
  },

  sk: {
    "nav.categories": "Kategórie",
    "nav.how": "Ako to funguje",
    "nav.partners": "Pre partnerov",
    "nav.about": "O nás",
    "nav.login": "Prihlásiť sa",
    "nav.signup": "Registrácia",
    "nav.account": "Účet",
    "nav.garage": "Moja garáž",
    "nav.favorites": "Obľúbené",
    "nav.alerts": "Cenové upozornenia",
    "nav.profile": "Profil",
    "nav.logout": "Odhlásiť sa",
    "nav.dashboard": "Partnerský panel",

    "hero.badge": "Dôveryhodné v strednej Európe",
    "hero.title": "Porovnajte autodiely v SK, CZ, PL a HU",
    "hero.subtitle": "Jedno vyhľadávanie naprieč overenými predajcami. Porovnajte celkovú cenu, dopravu, dodaciu dobu a hodnotenie predajcu — nájdite správny diel za správnu cenu.",
    "hero.search.oem": "OEM číslo",
    "hero.search.ean": "EAN / čiarový kód",
    "hero.search.name": "Názov dielu",
    "hero.search.vehicle": "Vozidlo",
    "hero.search.placeholder": "napr. brzdový kotúč, 1K0615301, Škoda Octavia",
    "hero.search.button": "Porovnať ceny",
    "hero.stat.retailers": "Overení predajcovia",
    "hero.stat.parts": "Indexovaných dielov",
    "hero.stat.markets": "Trhy",

    "cat.title": "Prehľadávať podľa kategórie",
    "cat.subtitle": "Originálne, OE a náhradné diely od preverených predajcov.",
    "cat.view": "Zobraziť všetko",
    "cat.count": "produktov",

    "how.title": "Ako funguje PartFinder",
    "how.subtitle": "Transparentné porovnanie v troch krokoch.",
    "how.s1.title": "Hľadajte",
    "how.s1.text": "Zadajte OEM číslo, EAN, názov dielu alebo vozidlo a nájdite zhodné diely.",
    "how.s2.title": "Porovnajte",
    "how.s2.text": "Pozrite si celkovú cenu, dopravu, dodaciu dobu, sklad a hodnotenie predajcu vedľa seba.",
    "how.s3.title": "Kúpte u predajcu",
    "how.s3.text": "Pokračujte k overenému predajcovi s najlepšou ponukou — bez prirážky.",

    "trust.title": "Postavené na dôvere a transparentnosti",
    "trust.subtitle": "Ponuky zoraďujeme podľa celkovej hodnoty, nikdy nie podľa toho, kto zaplatí najviac.",
    "trust.1.title": "Celková cena, nie len cenovka",
    "trust.1.text": "Doprava a dodanie sú vždy zahrnuté, aby ste porovnávali rovnaké s rovnakým.",
    "trust.2.title": "Iba overení predajcovia",
    "trust.2.text": "Každý partner je preverený na registráciu DPH a spoľahlivosť dodania.",
    "trust.3.title": "Nezávislá metodika",
    "trust.3.text": "Naše zoraďovanie je zdokumentované a otvorené.",
    "trust.method": "Prečítajte si metodiku",

    "partner.title": "Predávajte viac dielov na štyroch trhoch",
    "partner.subtitle": "Oslovte kupujúcich v SK, CZ, PL a HU z jednej integrácie. Feedy cez API, XML alebo CSV.",
    "partner.cta": "Staňte sa partnerom",
    "partner.b1": "Bezplatné napojenie a import katalógu",
    "partner.b2": "Deduplikácia OEM/EAN",
    "partner.b3": "Plaťte len za kvalifikované kliknutia",

    "footer.tagline": "Nezávislé porovnanie autodielov pre strednú Európu.",
    "footer.company": "Spoločnosť",
    "footer.legal": "Právne",
    "footer.resources": "Zdroje",
    "footer.rights": "Všetky práva vyhradené.",

    "search.results": "výsledkov",
    "search.filters": "Filtre",
    "search.category": "Kategória",
    "search.country": "Krajina odoslania",
    "search.instock": "Len skladom",
    "search.sort": "Zoradiť podľa",
    "search.sort.price_asc": "Najnižšia celková cena",
    "search.sort.price_desc": "Najvyššia celková cena",
    "search.sort.offers": "Najviac ponúk",
    "search.sort.name": "Názov A–Z",
    "search.empty": "Nenašli sa žiadne diely. Skúste iné vyhľadávanie.",
    "search.all": "Všetky kategórie",
    "search.allc": "Všetky krajiny",
    "search.from": "od",
    "search.offers": "ponúk",

    "product.offers": "Ponuky od predajcov",
    "product.compat": "Kompatibilita s vozidlom",
    "product.specs": "Detaily",
    "product.oem": "OEM čísla",
    "product.ean": "EAN",
    "product.brand": "Značka",
    "product.category": "Kategória",
    "product.total": "Spolu",
    "product.price": "Cena",
    "product.shipping": "Doprava",
    "product.delivery": "Dodanie",
    "product.seller": "Predajca",
    "product.stock": "Sklad",
    "product.country": "Krajina",
    "product.gotoseller": "Prejsť k predajcovi",
    "product.days": "dní",
    "product.free": "Zdarma",
    "product.instock": "Skladom",
    "product.lowstock": "Málo skladom",
    "product.backorder": "Na objednávku",
    "product.bestdeal": "Najlepšia ponuka",
    "product.addfav": "Uložiť",
    "product.remfav": "Uložené",
    "product.setalert": "Nastaviť upozornenie",

    "auth.login.title": "Vitajte späť",
    "auth.login.subtitle": "Prihláste sa a spravujte garáž, obľúbené a upozornenia.",
    "auth.register.title": "Vytvorte si účet",
    "auth.register.subtitle": "Ukladajte vozidlá, sledujte ceny a dostávajte upozornenia.",
    "auth.name": "Celé meno",
    "auth.email": "E-mail",
    "auth.password": "Heslo",
    "auth.login.button": "Prihlásiť sa",
    "auth.register.button": "Vytvoriť účet",
    "auth.toRegister": "Nemáte účet? Zaregistrujte sa",
    "auth.toLogin": "Máte už účet? Prihláste sa",

    "garage.title": "Moja garáž",
    "garage.subtitle": "Uložte si vozidlá pre rýchlejšie hľadanie kompatibilných dielov.",
    "garage.add": "Pridať vozidlo",
    "garage.empty": "Zatiaľ žiadne vozidlá. Pridajte svoje prvé auto.",
    "fav.title": "Obľúbené",
    "fav.subtitle": "Diely, ktoré ste si uložili na neskôr.",
    "fav.empty": "Zatiaľ nemáte žiadne obľúbené.",
    "alerts.title": "Cenové upozornenia",
    "alerts.subtitle": "Upozorníme vás, keď cena klesne na vašu cieľovú cenu.",
    "alerts.empty": "Zatiaľ žiadne upozornenia.",
    "alerts.target": "Cieľová cena",
    "alerts.current": "Aktuálne najlepšia",
    "profile.title": "Profil a nastavenia",

    "partnerform.title": "Staňte sa partnerom",
    "partnerform.subtitle": "Povedzte nám o svojom obchode. Žiadosti posudzujeme do 2 pracovných dní.",
    "partnerform.company": "Názov spoločnosti",
    "partnerform.contact": "Kontaktná osoba",
    "partnerform.phone": "Telefón",
    "partnerform.website": "Web",
    "partnerform.catalog": "Veľkosť katalógu",
    "partnerform.feed": "Preferovaný typ feedu",
    "partnerform.message": "Správa",
    "partnerform.submit": "Odoslať žiadosť",
    "partnerform.success": "Žiadosť prijatá! Čoskoro sa vám ozveme.",

    "contact.title": "Kontaktujte nás",
    "contact.subject": "Predmet",
    "contact.send": "Odoslať správu",
    "contact.success": "Ďakujeme — vaša správa bola odoslaná.",

    "common.loading": "Načítava sa…",
    "common.remove": "Odstrániť",
    "common.save": "Uložiť",
    "common.cancel": "Zrušiť",
    "common.required": "Vyžaduje sa prihlásenie",
    "common.loginPrompt": "Pre túto funkciu sa prosím prihláste.",
  },

  cs: {
    "nav.categories": "Kategorie", "nav.how": "Jak to funguje", "nav.partners": "Pro partnery",
    "nav.about": "O nás", "nav.login": "Přihlásit se", "nav.signup": "Registrace",
    "nav.garage": "Moje garáž", "nav.favorites": "Oblíbené", "nav.alerts": "Cenová upozornění",
    "nav.profile": "Profil", "nav.logout": "Odhlásit se", "nav.dashboard": "Partnerský panel",
    "hero.badge": "Důvěryhodné ve střední Evropě",
    "hero.title": "Porovnejte autodíly v SK, CZ, PL a HU",
    "hero.subtitle": "Jedno vyhledávání napříč ověřenými prodejci. Porovnejte celkovou cenu, dopravu, dodací dobu a hodnocení prodejce.",
    "hero.search.button": "Porovnat ceny",
    "hero.search.placeholder": "např. brzdový kotouč, 1K0615301, Škoda Octavia",
    "cat.title": "Procházet podle kategorie", "how.title": "Jak PartFinder funguje",
    "partner.title": "Prodávejte více dílů na čtyřech trzích", "partner.cta": "Staňte se partnerem",
    "search.filters": "Filtry", "product.offers": "Nabídky od prodejců", "product.bestdeal": "Nejlepší nabídka",
  },

  pl: {
    "nav.categories": "Kategorie", "nav.how": "Jak to działa", "nav.partners": "Dla partnerów",
    "nav.about": "O nas", "nav.login": "Zaloguj się", "nav.signup": "Rejestracja",
    "nav.garage": "Mój garaż", "nav.favorites": "Ulubione", "nav.alerts": "Alerty cenowe",
    "nav.profile": "Profil", "nav.logout": "Wyloguj się", "nav.dashboard": "Panel partnera",
    "hero.badge": "Zaufane w Europie Środkowej",
    "hero.title": "Porównaj części samochodowe w SK, CZ, PL i HU",
    "hero.subtitle": "Jedno wyszukiwanie u zweryfikowanych sprzedawców. Porównaj cenę całkowitą, dostawę, czas i oceny.",
    "hero.search.button": "Porównaj ceny",
    "hero.search.placeholder": "np. tarcza hamulcowa, 1K0615301, Škoda Octavia",
    "cat.title": "Przeglądaj według kategorii", "how.title": "Jak działa PartFinder",
    "partner.title": "Sprzedawaj więcej części na czterech rynkach", "partner.cta": "Zostań partnerem",
    "search.filters": "Filtry", "product.offers": "Oferty sprzedawców", "product.bestdeal": "Najlepsza oferta",
  },

  hu: {
    "nav.categories": "Kategóriák", "nav.how": "Hogyan működik", "nav.partners": "Partnereknek",
    "nav.about": "Rólunk", "nav.login": "Bejelentkezés", "nav.signup": "Regisztráció",
    "nav.garage": "Garázsom", "nav.favorites": "Kedvencek", "nav.alerts": "Árriasztások",
    "nav.profile": "Profil", "nav.logout": "Kijelentkezés", "nav.dashboard": "Partner irányítópult",
    "hero.badge": "Megbízható Közép-Európában",
    "hero.title": "Hasonlítsa össze az alkatrészeket SK, CZ, PL és HU piacon",
    "hero.subtitle": "Egyetlen keresés ellenőrzött kereskedőknél. Hasonlítsa össze a teljes árat, szállítást, időt és értékelést.",
    "hero.search.button": "Árak összehasonlítása",
    "hero.search.placeholder": "pl. féktárcsa, 1K0615301, Škoda Octavia",
    "cat.title": "Böngészés kategóriák szerint", "how.title": "Hogyan működik a PartFinder",
    "partner.title": "Adjon el több alkatrészt négy piacon", "partner.cta": "Legyen partner",
    "search.filters": "Szűrők", "product.offers": "Kereskedői ajánlatok", "product.bestdeal": "Legjobb ajánlat",
  },
};
